import React from "react";
import "./exchange-locations-add-rule.scss";
import {Tooltip} from "../../../../../../components/tooltip/tooltip";
import Icon from "../../../../../../components/icons/icon/icon";
import IconInfo from "../../../../../../components/icons/icon-info/icon-info";
import IconWhatsNew from "../../../../../../components/icons/icon-whatsnew/icon-whatsnew";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../components/fonts/font-props";
import {BUTTON_VARIANTS} from "../../../../../../components/inputs/button-variants";
import {Button} from "../../../../../../components/inputs/button/button";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

/**
 * Header component for exchange locations section with "Add Rule" button.
 * Displays title, tooltip, and action button.
 */
export interface IExchangeLocationsAddRule {
    onActionClick?: () => void;
    actionDisabled?: boolean;
    actionLoading?: boolean;
}

export const ExchangeLocationsAddRule: React.FC<IExchangeLocationsAddRule> = ({
    onActionClick,
    actionDisabled,
    actionLoading
}) => {

    const {getTranslation} = useDashboardTranslation();
    const pageScope = 'dashboard-settings-store';

    const warehousesAndRegionsConnectionText = getTranslation('WAREHOUSES_AND_REGIONS_CONNECTION', pageScope);
    const warehousesAndRegionsConnectionNoteText = getTranslation('WAREHOUSES_AND_REGIONS_CONNECTION_NOTE', pageScope);
    const addWhRuleText = "+ " + getTranslation('ADD_WH_RULE', pageScope);

    return (
        <div className="exchange-locations-add-rule">
            <div className="exchange-locations-add-rule-title">
                <div className="exchange-locations-add-rule-leading-icon">
                    <Icon Component={IconWhatsNew}/>
                </div>

                <div className="exchange-locations-add-rule-title-content">
                    <FontBody1 variant={FONT_VARIANT.BOLD}>{warehousesAndRegionsConnectionText}</FontBody1>
                </div>

                <Tooltip content={
                    <div style={{maxWidth: '300px', whiteSpace: 'normal', wordWrap: 'break-word'}}>
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>{warehousesAndRegionsConnectionNoteText}</FontBody2>
                    </div>
                }>
                    <Icon Component={IconInfo}/>
                </Tooltip>
            </div>

            <div className="exchange-locations-add-rule-action">
                <Button
                    variant={BUTTON_VARIANTS.PrimaryAccent}
                    text={addWhRuleText}
                    disabled={actionDisabled}
                    onClick={onActionClick}
                    isLoading={actionLoading}
                    hasLoader={actionLoading}
                />
            </div>
        </div>
    );
}